import { render, staticRenderFns } from "./testindex.vue?vue&type=template&id=326b0954&scoped=true"
import script from "./testindex.vue?vue&type=script&lang=js"
export * from "./testindex.vue?vue&type=script&lang=js"
import style0 from "./testindex.vue?vue&type=style&index=0&id=326b0954&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326b0954",
  null
  
)

export default component.exports